import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import * as Colors from "@mui/material/colors";
import { baseColors } from "theme";

export const styles = (theme: Theme) => {
	return ({
		container: {
			display: "flex",
			flexDirection: "column",
			padding: "10px 0"
		},
		titleRow: {
			display: "flex",
			flexDirection: "row",
			alignItems: "center",
		},
		leadName: {
			color: theme.palette.primary.main,
			marginLeft: 0,
			cursor: 'pointer',
			textDecoration: 'underline',
		},
		checkbox: {
			height: 48,
			width: 48,
			// marginRight: 10,
		},
		title: {
			color: baseColors.black,
			"&:hover": {
				textDecoration: "underline",
				cursor: "pointer"
			}
		},
		typeChip: {
			height: 32,
			backgroundColor: theme.palette.primary.faded,
			marginRight: 10,
			borderRadius: 16,
			padding: theme.spacing(1, 2),
			gap: theme.spacing(1.25),
			display: "flex",
			alignItems: "center",
			"& .MuiChip-label": {
				fontSize: 14,
				lineHeight: "20px",
				fontFamily: theme.typography.fontFamily,
				fontWeight: 400,
				// FLAG (MAX-3909 landmine 5): pre-existing no-op — `theme.palette.text` is the TypeText
				// object, emits `color: [object Object]` (ignored by the browser). Preserved as-authored.
				color: theme.palette.text as unknown as string,
				padding: 0
			},
			"& .MuiChip-icon": {
				margin: 0,
				width: 16,
				height: 16,
				color: theme.palette.primary.main
			}
		},
		date: {
			fontSize: 13,
			alignSelf: "center",
		},
		noWrapTypographyWrapper: {
			textOverflow: "ellipsis",
			overflow: "hidden",
			width: "100%"
		}
	} satisfies Record<string, CSSObject>);
};
